export default __webpack_public_path__ + "static/media/024-furniture.ecde75b3.svg";